import React, { useEffect, useState } from 'react';
import { animateScroll as scroll } from 'react-scroll';

import NavBar from '../../components/NavBar';
import LogoBar from '../../components/LogoBar';
import LoadingSpinner from '../../components/LoadingSpinner';
import FloatingButtons from '../../components/FloatingButtons';
import ContentHeader from '../../components/ContentHeader';
import ContentIndex from '../../components/ContentIndex';
import ContentContainer from '../../components/ContentContainer';

import { getWordPressData } from '../../utils/api';

import './styles.css';
import './print.css';

const HomePage = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        const url = 'https://childhood.org.br/api/chb/v1/ncs';

        getWordPressData(url).then((response) => {
            setData(response);
            setLoading(false);
        });
    }, []);

    const scrollToTop = () => {
        scroll.scrollToTop({
            duration: 300,
            smooth: 'easeInOutQuart',
        });
    };

    const shareWebsite = () => {
        let message =
            'Conheça o Navegar com Segurança, uma iniciativa da Childhood Brasil pela proteção de crianças e adolescentes no mundo digital. ';

        message +=
            currentPage > 0
                ? `Acesse ${window.location.href} e leia a ilha "${data[currentPage].island}"!`
                : `Acesse: ${window.location.href}`;

        navigator.clipboard
            .writeText(message)
            .then(() => {
                alert(
                    'Mensagem copiada para a área de transferência. Compartilhe em suas redes sociais!'
                );
            })
            .catch((error) => {
                console.error(
                    'Erro ao copiar para a área de transferência:',
                    error
                );
            });
    };

    const changePage = (index) => {
        setCurrentPage(index);
        scrollToTop();
    };

    const onClick = (target) => {
        if (target.classList.contains('btn-scroll')) {
            scrollToTop();
        } else if (target.classList.contains('btn-share')) {
            shareWebsite();
        } else if (target.classList.contains('btn-download')) {
            window.print();
        }
    };

    return (
        <div
            id='ncs-home-page'
            className={data ? `color-scheme-${currentPage}` : ''}
            onClick={(e) => onClick(e.target)}
        >
            {data && <FloatingButtons data={data} changePage={changePage} />}
            <LogoBar />
            <NavBar
                data={data}
                currentPage={currentPage}
                changePage={changePage}
            />
            {loading && <LoadingSpinner />}
            {data &&
                data
                    .filter((_, index) => index === currentPage)
                    .map((page, index) => {
                        return (
                            <div key={index}>
                                <ContentHeader content={page} />
                                <ContentIndex content={page} />
                                <ContentContainer
                                    data={data}
                                    content={page}
                                    changePage={changePage}
                                />
                            </div>
                        );
                    })}
        </div>
    );
};

export default HomePage;
